export const theme = {
    colors: {
        skyBlue: '#4D91DE',
        white: '#FFFFFF',
        darkFont: '#555555',
        bgColor: 'hsl(0, 0%, 98%)',
        bgColor2: '#FAFAFA',
        blueBgColor: 'rgba(255,255,255,.75)',
        black: '#222222',
        navColor: '#999999',
        lightGray: '#e5e5e5'
    },
}